<div class="nk-content nk-content-fluid slideshow-bg" [style.background-image]="'url(' + currentImage + ')'">
  <div class="slideshow-overlay"></div>
  <div class="container-xl wide-xl position-relative">
    <div class="nk-content-inner">
      <div class="nk-content-body">
        <!-- Cabeçalho -->
        <div class="nk-block-head nk-block-head-lg wide-xs mx-auto mt-4">
          <div class="nk-block-head-content text-center">
            <h6 class="nk-block-title fw-bold text-uppercase text-white text-shadow">Bem-vindo / Welcome / Bienvenue
            </h6>
            <div class="nk-block-des">
              <p class="text-uppercase text-white text-shadow">Plataforma do Mapeamento da Diáspora Cabo-verdiana</p>
            </div>
          </div>
        </div>
      </div>
      <!-- Formulário de Seleção de Idioma -->
      <div class="nk-block mt-4">
        <div class="card card-custom-s1 card-bordered shadow-lg p-4 home-card"
          style="background-color:rgba(255, 255, 255, 0.9);">
          <div class="row no-gutters">
            <div class="col-lg-12">
              <div class="card-inner card-inner-lg h-100">
                <div class="align-center flex-wrap flex-md-nowrap g-3 h-100">
                  <form class="form-validate is-alter" novalidate="novalidate">
                    <div class="nk-block-content">
                      <div class="nk-block-content-head text-center mb-4">
                        <h4 class="text-uppercase">Idioma / Language / Langue</h4>
                      </div>
                      <p class="ff-italic fs-10px text-center mb-4">Escolha o idioma que mais domina para facilitar na
                        compreensão do
                        formulário /
                        Choose the language you are most comfortable with to facilitate understanding of the form /
                        Choisissez la langue que vous maîtrisez le mieux pour faciliter la compréhension du
                        formulaire.
                      </p>
                      <ul class="row g-3 mb-4 justify-content-center">
                        <li class="col-4 col-md-4 language-option">
                          <div
                            class="custom-control custom-control-sm custom-radio pro-control pro-control-border custom-control-full">
                            <input type="radio" class="custom-control-input" name="idioma" id="idioma_pt" value="pt"
                              [(ngModel)]="lang" required>
                            <label class="custom-control-label" for="idioma_pt">
                              <span class="d-flex flex-column text-center px-sm-3">
                                <span class="icon-wrap text-primary mt-4 mt-md-0">
                                  <div class="quick-icon border border-light">
                                    <img class="icon" src="assets/images/flags/caboverde.svg" alt="">
                                  </div>
                                </span>
                                <span class="lead-text mb-1 mt-md-3">PT</span>
                                <span class="sub-text d-none d-md-inline">Português</span>
                              </span>
                            </label>
                          </div>
                        </li>
                        <li class="col-4 col-md-4 language-option">
                          <div
                            class="custom-control custom-control-sm custom-radio pro-control pro-control-border custom-control-full">
                            <input type="radio" class="custom-control-input" name="idioma" id="idioma_en" value="en"
                              [(ngModel)]="lang" required>
                            <label class="custom-control-label" for="idioma_en">
                              <span class="d-flex flex-column text-center px-sm-3">
                                <span class="icon-wrap text-primary mt-4 mt-md-0">
                                  <div class="quick-icon border border-light">
                                    <img class="icon" src="assets/images/flags/english.png" alt="">
                                  </div>
                                </span>
                                <span class="lead-text mb-1 mt-md-3">EN</span>
                                <span class="sub-text d-none d-md-inline">English</span>
                              </span>
                            </label>
                          </div>
                        </li>
                        <li class="col-4 col-md-4 language-option">
                          <div
                            class="custom-control custom-control-sm custom-radio pro-control pro-control-border custom-control-full">
                            <input type="radio" class="custom-control-input" name="idioma" id="idioma_fr" value="fr"
                              [(ngModel)]="lang" required>
                            <label class="custom-control-label" for="idioma_fr">
                              <span class="d-flex flex-column text-center px-sm-3">
                                <span class="icon-wrap text-success mt-4 mt-md-0">
                                  <div class="quick-icon border border-light">
                                    <img class="icon" src="assets/images/flags/french.png" alt="">
                                  </div>
                                </span>
                                <span class="lead-text mb-1 mt-md-3">FR</span>
                                <span class="sub-text d-none d-md-inline">Français</span>
                              </span>
                            </label>
                          </div>
                        </li>
                      </ul>
                      <div class="text-center">
                        <button type="button" (click)="onLangClick()" class="btn btn-lg btn-primary home-cta">Começar / Get
                          Started /
                          Commencer</button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div class="col-lg-12 py-2 mb-4">
              <ul class="nav justify-center gx-8">
                <li class="nav-item"><a href="https://www.facebook.com/sharer/sharer.php?u={{ mdcLink }}"
                    target="_blank" class="link link-primary fw-normal py-2 px-3" href="#">
                    <p class="fw-medium">Share on Facebook</p>
                  </a></li>
                <li class="nav-item"><a
                    href="https://www.facebook.com/dialog/send?app_id=your-app-id&link={{ mdcLink }}&redirect_uri={{ mdcLink }}"
                    target="_blank" class="link link-primary fw-normal py-2 px-3" href="#">
                    <p class="fw-medium">Share on Messenger</p><span
                      class="fa-brands fa-facebook-messenger me-2"></span>
                  </a></li>
                <li class="nav-item"><a href="https://wa.me/?text={{ mdcLink }}" target="_blank"
                    class="link link-primary fw-normal py-2 px-3" href="#">
                    <p class="fw-medium">Share on WhatsApp</p>
                  </a></li>
              </ul>
            </div>
          </div>
        </div>
        <!-- Rodapé dos Patrocinadores -->
        <div class="nk-block mt-4">
          <div class="card bg-transparent">
            <div class="card-inner card-inner-lg text-center">
              <h6 class="text-uppercase text-white text-shadow">Intervenientes / Patrocinador</h6>
              <div class="row justify-content-center mt-5">                
                <div class="col-6 col-md-3 mb-5 mb-md-0">
                  <a target="_blank" href="https://www.facebook.com/ministerio_das_comunidades"><img
                      src="assets/images/intervenientes/logo2.png" alt="Patrocinador 1"
                      class="img-fluid img-shadow"></a>
                </div>   
                 <div class="col-6 col-md-3 mb-5 mb-md-0">
                  <a target="_blank" href="https://ine.cv"><img src="assets/images/intervenientes/logo1.png"
                      alt="Patrocinador 2" class="img-fluid img-shadow"></a>
                </div>
                 <div class="col-6 col-md-3 mb-md-0">
                  <a target="_blank" href="https://ugpe.gov.cv"> <img src="assets/images/intervenientes/logo5.png"
                      alt="Patrocinador 3" class="img-fluid img-shadow"></a>
                </div>
                <div class="col-6 col-md-3 mb-md-0">
                  <a target="_blank" href="https://www.worldbank.org"><img src="assets/images/intervenientes/logo4.png"
                      alt="Patrocinador 4" class="img-fluid img-shadow"></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
